import { UserSettings } from "@domain/Settings";
import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class Contact extends BaseDataModel {
	name!: string;
	firstName!: string;
	lastName!: string;
	email!: string;

	isSalesperson!: boolean;

	companyIds!: string[];
	companyIdsDm!: string[];
	companyIdsAll!: string[];
	branchIds!: string[];
	salespersonBranchIds!: string[];
	proagricaAuth!: string;
	portalSettings!: UserSettings;

	mobilePhone!: string;

	static newSalesperson(id: string, name: string, firstName?: string, lastName?: string): Contact {
		return {
			id: id,
			name: name,
			firstName: firstName ?? "",
			lastName: lastName ?? "",
			email: "",

			isSalesperson: true,

			companyIds: [],
			companyIdsDm: [],
			companyIdsAll: [],
			branchIds: [],
			salespersonBranchIds: [],
			proagricaAuth: "",
			portalSettings: { views: [] },

			mobilePhone: "",
		} as Contact;
	}
}
